import React from 'react'
import { cva } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const buttonVariants = cva(
  'btn-dreamy',
  {
    variants: {
      variant: {
        primary: 'btn-primary',
        secondary: 'btn-secondary',
        accent: 'bg-gradient-to-r from-accent-500 to-accent-600 text-white hover:from-accent-600 hover:to-accent-700 shadow-playful hover:shadow-lg focus:ring-accent-500',
        warm: 'bg-gradient-to-r from-warm-500 to-warm-600 text-white hover:from-warm-600 hover:to-warm-700 shadow-playful hover:shadow-warm-glow focus:ring-warm-500',
        outline: 'border-2 border-primary-500 text-primary-600 hover:bg-primary-50 focus:ring-primary-500 bg-white/60 backdrop-blur-sm',
        ghost: 'text-primary-600 hover:bg-primary-50 hover:text-primary-700 focus:ring-primary-500 bg-transparent shadow-none',
        link: 'text-primary-600 underline-offset-4 hover:underline focus:ring-0 shadow-none p-0',
      },
      size: {
        sm: 'px-3 py-1.5 text-xs rounded-xl',
        default: 'px-6 py-3 text-sm rounded-2xl',
        lg: 'px-8 py-4 text-base rounded-2xl',
        xl: 'px-10 py-5 text-lg rounded-3xl',
        icon: 'h-10 w-10 rounded-xl',
      },
      animation: {
        none: '',
        bounce: 'hover:animate-bounce-slow',
        float: 'animate-float',
        sparkle: 'animate-sparkle',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default',
      animation: 'none',
    },
  }
)

const Button = React.forwardRef(({
  className,
  variant,
  size,
  animation,
  asChild = false,
  children,
  ...props
}, ref) => {
  if (asChild) {
    // For asChild functionality, we'd need @radix-ui/react-slot
    // For now, just render as regular button
    console.warn('asChild prop requires @radix-ui/react-slot package')
  }

  return (
    <button
      className={cn(buttonVariants({ variant, size, animation, className }))}
      ref={ref}
      {...props}
    >
      {children}
    </button>
  )
})

Button.displayName = "Button"

export { Button, buttonVariants }